import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';

export const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/404',
}).lazy(() => import('pages/shared/errors/Page404/Page404').then((d) => d.Route));
